/**
 * Cirrus Specs API Service
 * Handles API calls for Cirrus Configurator CSV upload and status
 */

import { getAuth } from 'firebase/auth';

const API_BASE_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:8080/api'
  : 'https://lm-reports-889856480589.us-central1.run.app/api';

async function getAuthHeaders() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  const token = await user.getIdToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

/**
 * Get current status of Cirrus configurator CSV
 * @returns {Promise<Object>} Status object
 */
export async function getCirrusSpecsStatus() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/cirrus-specs/status`, {
    headers,
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to get status');
  }
  return response.json();
}

/**
 * Upload Cirrus configurator CSV
 * @param {string} csvContent - CSV content as string
 * @returns {Promise<Object>} Upload result
 */
export async function uploadCirrusSpecs(csvContent) {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/cirrus-specs/upload`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      csvContent,
      contentEncoding: 'text',
    }),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.details || error.error || 'Failed to upload CSV');
  }
  return response.json();
}

/**
 * Get version history (admin only)
 * @returns {Promise<Object>} Object with versions array
 */
export async function getCirrusSpecsVersions() {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/cirrus-specs/versions`, {
    headers,
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || 'Failed to get versions');
  }
  return response.json();
}
